import { useIntl } from 'react-intl';
import { Queue } from '@rossum/api-client/queues';
import {
  BreadcrumbItem,
  Breadcrumbs,
} from '@rossum/components/breadcrumbs/Breadcrumbs';
import { Tooltip } from '@rossum/ui/material';
import { settingsPath } from '../../../containers/Settings/helpers';
import { truncateQueueLabel } from '../../../utils/truncateQueueLabel';
import { queueManagerPath } from '../../queue-manager/routes';

type QueueSettingsBreadcrumbsProps = {
  queue: Queue;
  workspaceName: string;
  breadcrumbs: BreadcrumbItem[];
};

export const QueueSettingsBreadcrumbs = ({
  queue,
  workspaceName,
  breadcrumbs,
}: QueueSettingsBreadcrumbsProps) => {
  const intl = useIntl();
  const { id, name } = queue;

  const { truncatedLabel, showTooltip, fullLabel } = truncateQueueLabel(
    name,
    workspaceName
  );

  const queueSettingsBreadcrumbs = [
    {
      label: intl.formatMessage({
        id: 'features.queueSettings.breadcrumbs.settings',
      }),
      to: settingsPath(),
    },
    {
      label: intl.formatMessage({
        id: 'features.queueSettings.breadcrumbs.queues',
      }),
      to: queueManagerPath(),
    },
    {
      label: showTooltip ? (
        <Tooltip title={fullLabel}>
          <span>{truncatedLabel}</span>
        </Tooltip>
      ) : (
        truncatedLabel
      ),
      to: `/queues/${id}/settings/basic`,
    },
    ...breadcrumbs,
  ] as const;

  return <Breadcrumbs breadcrumbs={queueSettingsBreadcrumbs} />;
};
